import { ComparisonSelection as Selection } from "@/components/comparison/ComparisonSelection";
import type { ComparisonSelection } from "@/stores/profile-comparison-store";
import { profileComparable } from "./profile-comparable";
export function ProfileComparisonSelection({ viewerId, currentProfile }: { viewerId: string; currentProfile?: ComparisonSelection }) {
  return <Selection comparable={profileComparable} viewerId={viewerId} current={currentProfile} />;
}
